<template>
  <div class="modal" :class="show? 'show': ''" :style="show? 'display:block;': ''" aria-hidden="true" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form role="form" @submit.prevent="todoSubmit" class="col-md-12">
            <div class="row">
              <div class="form-group col-md-12">
                <label for="totoTitle">List name</label>
                <input type="text" v-model="todo.displayName" class="form-control" id="totoTitle" name="todoTitle" placeholder="Add a list name">
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="saveTodo()">Save</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="$emit('close')">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'TodoModal',
  components: {},
  props: {
    show: Boolean,
    info: Object
  },
  data() {
    return {
      todo: {
        displayName: ""
      },
      title: ""
    }
  },
  mounted() {
    if (this.isEmpty(this.info.todo)) {
      this.title = "Create new todo list";
    }
    else {
      this.title = "Edit todo list";
      this.todo.displayName = this.info.todo.displayName;
    }
  },
  methods: {
    todoSubmit() {

    },
    isEmpty(obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop))
          return false;
      }
      return true;
    },
    saveTodo() {
      if (this.info.todoId) {
        axios.patch(this.crmApiPath + 'msgraph/todo/lists/' + this.info.todoId, this.todo).then(response => {
          if (response.data.is_redirect) {
            window.location.href = response.data.redirect_url;
          }
          else {
            this.$emit('close');
          }
        }).catch(error => console.log(error));
      }
      else {
        axios.post(this.crmApiPath + 'msgraph/todo/lists', this.todo).then(response => {
          if (response.data.is_redirect) {
            window.location.href = response.data.redirect_url;
          }
          else {
            this.$emit('close');
          }
        }).catch(error => console.log(error));
      }
    },
  },
}
</script>
<style scoped lang="scss">
.modal-dialog {
  min-height:      calc(100vh - 60px);
  display:         flex;
  flex-direction:  column;
  justify-content: center;
  overflow:        auto;
}

@media(max-width: 768px) {
  .modal-dialog {
    min-height: calc(100vh - 20px);
  }
}
</style>
<style lang="scss">

</style>
